import { render, staticRenderFns } from "./ViewTransaction.vue?vue&type=template&id=7d541a68&"
import script from "./ViewTransaction.vue?vue&type=script&lang=js&"
export * from "./ViewTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports